(ns guidebook.views.risk-questionnaire
  (:require
    [very.re-frame.core :as rf]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [guidebook.common :as gc :refer [format-date]]
    [css.core :refer [defstyled get-theme]]))

(defstyled page-s :div
  {:padding "150px 100px"
   :min-height "100vh"
   ::cljss/media {[:print]
                  {:padding "82px 100px 150px"}}})

(defstyled row-s :div
  {:display "grid"
   :grid-gap "0 4rem"
   :align-items "center"
   :padding "1.5rem"
   :border-bottom (with-meta #(if % (str "2px solid " (get-theme :primary)) (str "1px solid " vars/border-light)) :header?)
   :grid-template-columns (with-meta #(if % "3fr 2fr" "1fr 1fr 1fr") :r2?)})

(defstyled label-s :label
  {:text-align "right"
   :font-weight "700"
   :font-size "1.125rem"
   :line-height "1.7rem"})

(defstyled value-s :div
  {:text-align "center"
   :font-size "1.125rem"
   :line-height "1.7rem"})

(defstyled th-s :div
  {:text-align "center"})

(defstyled th-label-s :label
  {:font-weight "700"
   :color vars/gray
   :text-transform "uppercase"
   :font-size ".8rem"
   :margin-bottom ".5rem"})

(defstyled th-time-s :div
  {:font-size "1.125rem"
   :font-weight "700"})

(defn make-header- [{:keys [r1 r2]}]
  [row-s {:r2? (empty? r2)
          :header? true}
   [:div]
   (when r2
     [th-s
      [th-label-s "Previous Survey"]
      [th-time-s (format-date (:created-at r2))]])
   [th-s
    [th-label-s "Most Recent Survey"]
    [th-time-s (format-date (:created-at r1))]]])

(defn make-row- [{:keys [label r1 r2]}]
  "r1 = most recent"
  [row-s {:r2? (empty? r2)}
   [label-s label]
   (when r2 [value-s r2])
   [value-s r1]])

(defn main []
  (let [risk (rf/subscribe [:guidebook/risk-profile])]
    (fn []
      (let [r1 (first @risk)
            r2 (second @risk)]
        [page-s
         [gc/title-s {:margin "0 0 4rem"} "Risk Questions"]
         [make-header- {:r1 r1
                        :r2 r2}]
         [make-row- {:label "By what percentage do you expect your portfolio to grow annually over the long-term (10+ years)?"
                     :r1 (:growth r1)
                     :r2 (:growth r2)}]
         [make-row- {:label "When I invest my money, I am:"
                     :r1 (:concerns r1)
                     :r2 (:concerns r2)}]
         [make-row- {:label "I would describe my knowledge of investments as:"
                     :r1 (:knowledge r1)
                     :r2 (:knowledge r2)}]
         [make-row- {:label "The potential 1-year risk/return tradeoff of a $100k investment that you would choose:"
                     :r1 (:tradeoff r1)
                     :r2 (:tradeoff r2)}]
         [make-row- {:label "The amount of loss in your portfolio that would make you anxious, assuming you start with $100,000?"
                     :r1 (:loss-anxiety r1)
                     :r2 (:loss-anxiety r2)}]
         [make-row- {:label "I plan to begin taking money from my investments in:"
                     :r1 (:timeframe r1)
                     :r2 (:timeframe r2)}]
         [make-row- {:label "Will you be looking for your investments to cover living expenses immediately?"
                     :r1 (:expenses r1)
                     :r2 (:expenses r2)}]]))))

